import { render, staticRenderFns } from "./ModalNeed.vue?vue&type=template&id=71c5d7be&scoped=true&"
import script from "./ModalNeed.vue?vue&type=script&lang=js&"
export * from "./ModalNeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c5d7be",
  null
  
)

export default component.exports